import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [sp] = useSearchParams();
  const orderId = sp.get("order_id");
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6">
      <div className="max-w-md w-full bg-card border border-foreground p-10 text-center">
        <XCircle className="w-14 h-14 mx-auto text-destructive mb-4" strokeWidth={1.5}/>
        <h1 className="text-2xl font-bold tracking-tight mb-2">Payment cancelled</h1>
        <p className="text-muted-foreground mb-6">Your order is still pending. You can retry payment or cancel the order.</p>
        <div className="flex gap-3 justify-center">
          {orderId && (
            <Link to={`/order/${orderId}`} data-testid="cancel-view-order" className="bg-primary text-primary-foreground px-5 py-2.5 mono text-xs">RETRY PAYMENT</Link>
          )}
          <Link to="/dashboard" className="border border-foreground px-5 py-2.5 mono text-xs">DASHBOARD</Link>
        </div>
      </div>
    </div>
  );
}
